// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import checkDone02Icon from "@/assets/icons/check-done-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CheckDone02IconProps = Omit<IconProps, "name">;

export function CheckDone02Icon(props: CheckDone02IconProps): React.ReactNode {
  return <Icon name={checkDone02Icon} {...props} />;
}
